import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SuiviDesConsommationsComponent} from './suivi-des-consommations/suivi-des-consommations.component';
import {RouterModule, Routes} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbDatepickerModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ComponentsModule} from '../../components/components.module';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {EditReleveComponent} from './edit-releve/edit-releve.component';
import {EnergieNamePipe} from './pipes/energie-name.pipe';
import {HistoriqueReleveComponent} from './historique/historique-releve.component';
import {NgbDateToIsoPipe} from '../../pipes/ngbdate-to-iso.pipe';
import {EnergieIconPipe} from './pipes/energie-icon.pipe';
import {ParametrageUsagesComponent} from './parametrage-usages/parametrage-usages.component';
import { AmpouleTypePipe } from './pipes/ampoule-type.pipe';
import { EnergieUnitPipe } from './pipes/energie-unit.pipe';
import { UsagePointSelectorComponent } from './usage-point-selector/usage-point-selector.component';
import {NgxMatomoTrackerModule} from 'ngx-matomo-client';
import {ConsumptionModule} from "../consumption/consumption.module";
import {ActiveConsumptionPeriodComponent} from "./active-consumption-period/active-consumption-period";
import {
  ActiveConsumptionPeriodModalComponent
} from "./active-consumption-period/active-consumption-period-modal/active-consumption-period-modal";

const routes: Routes = [
  {path: 'suivi-des-consommations', component: SuiviDesConsommationsComponent}
];

@NgModule({
  providers: [
    // { provide: ConsommationsService, useClass: MockConsommationsService },
    NgbDateToIsoPipe,
  ],
  declarations: [
    SuiviDesConsommationsComponent,
    EditReleveComponent,
    EnergieNamePipe,
    EnergieIconPipe,
    HistoriqueReleveComponent,
    ParametrageUsagesComponent,
    AmpouleTypePipe,
    EnergieUnitPipe,
    UsagePointSelectorComponent,
    ActiveConsumptionPeriodComponent,
    ActiveConsumptionPeriodModalComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    FontAwesomeModule,
    ComponentsModule,
    NgxChartsModule,
    FormsModule,
    NgxMatomoTrackerModule,
    NgbNavModule,
    ConsumptionModule,
  ],
  exports: [RouterModule]
})
export class Rt2012Module { }
